export default (val) => {
  if (val === 0) {
    return '停车场'
  } else if (val === 1) {
    return '标准营地'
  } else if (val === 2) {
    return '景点'
  } else if (val === 3) {
    return '美食'
  } else if (val === 4) {
    return '修理厂'
  } else if (val === 5) {
    return '加气'
  }
}



// WEBPACK FOOTER //
// ./src/filters/camp-type.js